import ChartistGraph from "react-chartist"
import React, { Component } from "react"
import abbreviate from "number-abbreviate"
export default class BarGraph extends Component {
  render() {
    var data = {
      labels: this.props.labels,
      series: this.props.values
    }

    var options = {
      high: this.props.max,
      low: 0,
      seriesBarDistance: 3,
      axisX: {
        labelInterpolationFnc: function(value, index) {
          return value
        }
      },
      axisY: {
        labelInterpolationFnc: function(value, index) {
          return abbreviate(value, 0)
        }
      }
    }

    var type = "Bar"
    var height = 350
    return (
      <div className={this.props.sizeClass | "col-md-12"}>
        <div className="card">
          <div
            style={{ height: height }}
            className="card-header card-chart"
            data-background-color={this.props.backgroundColor}
          >
            <div className="ct-chart">
              <ChartistGraph
                style={{ height: height }}
                data={data}
                options={options}
                type={type}
              />
            </div>
          </div>
          <div className="card-content">
            <h4 className="title">{this.props.title}</h4>
            <p className="category">{this.props.category}</p>
          </div>
          <div className="card-footer">
            <div className="stats">
              <i className="material-icons">access_time</i> {this.props.legenda}
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/BarGraph.js